export default __webpack_public_path__ + "media/src/shared/seller-services/assets/error-icon/error-icon-783abbdad12c1b3b412e208f18384a61.svg";